import React from 'react';
import { ModalToggleState } from '../../models/actionStates';
import { useSetModalState } from '../../hooks/actions/useModalState';
import { ReturnsDetail } from './ReturnsDetail';
import { DivButton } from '../../root/components/DivButton';
import { Icon } from '../../icons/Icon';
import contentStyles from '../../side_pages/SidePage.module.scss';
import { useRecoilValue } from 'recoil';
import { isMobileState } from '../../recoil/selectors';
import styles from '../../modal_singleton/Modal.module.scss';

export const ReturnsModal: React.FC = () => {
  const isMobile = useRecoilValue(isMobileState);
  const setModal = useSetModalState();
  const headerMargins = isMobile ? { margin: '60px 20px 0px 20px' } : { margin: '60px 0 0 80px' };

  return (
    <React.Fragment>
      <div className={styles.modalHeader}>
        <div className={styles.modalControl} />
        <span></span>
        <DivButton onClick={() => setModal({ toggleState: ModalToggleState.Closed })} className={styles.modalControl} label="Close modal">
          <Icon name="close" style={{ width: '12px' }} />
        </DivButton>
      </div>
      <div className={styles.modalBody}>
        <h1 style={{ ...headerMargins, fontSize: '42px', fontFamily: "'Ogg-Regular'", lineHeight: '46px', color: 'black' }}>Honeylove Returns</h1>
        <div className={contentStyles.content}>
          <ReturnsDetail hideCTA={true} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default ReturnsModal;
